import { Button, Input, Label, UncontrolledTooltip } from "reactstrap";

import Flex from "@components/ui-components/flex";
import classnames from "classnames";
import size from "lodash/size";
import useGroupBy from "./use-group-by";
import { useTranslation } from "react-i18next";

const SelectUnselectAll = (props) => {
    const { handleSelection } = props;
    const { t } = useTranslation();
    return (
        <Flex align="center">
            <Button
                className="btn-icon unselect-all-btn"
                id="unselect"
                outline
                data-cy="unselect-all"
                color={"danger"}
                onClick={() => handleSelection("clear")}>
                <i className="mdi mdi mdi-cancel" />
            </Button>
            <UncontrolledTooltip placement="top" target="unselect">
                {t("Clear All")}
            </UncontrolledTooltip>
            <Button
                className="btn-icon  select-all-btn"
                id="selectAll"
                outline
                data-cy="select-all"
                color="success"
                onClick={() => handleSelection("all")}>
                <i className="mdi mdi-checkbox-marked-outline cursor-pointer" />
            </Button>
            <UncontrolledTooltip placement="top" target="selectAll">
                {t("Select All")}
            </UncontrolledTooltip>
        </Flex>
    );
};
const GroupBy = (props) => {
    const {
        maxGroupByAllowed,
        groupByOptions
    } = props;

    const { handleSelectActions, selectedGroupBy, handleGroupBy } =
    useGroupBy(props);

    const { t } = useTranslation();
    return (
        <>
            <Flex justify="between" align="center">
                <div>
                    <h5 className="m-0 fw-bolder">{t("Group By")}</h5>
                    {maxGroupByAllowed ? (
                        <p className="text-muted">
                            {t(`Maximum ${maxGroupByAllowed} allowed`)}
                        </p>
                    ) : null}
                </div>
                <Flex justify="between" align="center">
                    <SelectUnselectAll handleSelection={handleSelectActions}/>
                </Flex>
            </Flex>
            <div className="group-row">
                {groupByOptions.map((item, index) => {
                    const isItemDisabled = item.disabled;
                    const maxAllowed = maxGroupByAllowed;
                    const isMaxGroupByAllowed = maxAllowed ? !selectedGroupBy?.includes(item.value) &&
              size(selectedGroupBy) === Number(maxAllowed) : false;
                    const isDisabled = isItemDisabled || isMaxGroupByAllowed;

                    return (
                        <div
                            className="position-relative"
                            key={index}
                            id={
                                selectedGroupBy?.includes(item.value) ? "" : `${item.value}-disabled-groupby`
                            }>
                            <Input
                                type="checkbox"
                                id={item.value}
                                disabled={isDisabled}
                                name={item.value}
                                onChange={({ target }) => {
                                    handleGroupBy(target.value);
                                }}
                                className={"fw-bolder m-0 customCheckbox"}
                                checked={selectedGroupBy?.includes(item.value)}
                                value={item.value}/>
                            <Label
                                htmlFor={item.value}
                                className={classnames(
                                    "font-small-2 mb-0 checkbox-label w-100 filter-checkbox",
                                    {
                                        active    : selectedGroupBy?.includes(item.value),
                                        border    : !selectedGroupBy?.includes(item.value),
                                        disabled  : isDisabled,
                                        "bg-white": !isDisabled
                                    }
                                )}>
                                <div className="label">
                                    {t(item.label)}
                                </div>
                            </Label>
                        </div>
                    );
                })}
            </div>
        </>
    );
};
export default GroupBy;
